export const SHOW_GLOBAL_SNACKBAR = 'SHOW_GLOBAL_SNACKBAR'

export const DISMISS_GLOBAL_SNACKBAR = 'DISMISS_GLOBAL_SNACKBAR'

export const CHANGE_SYSTEM_LANGUAGE = 'CHANGE_SYSTEM_LANGUAGE'
